<template>
  <div class="dash-modal-backdrop dash-modal-top" @click.self="close">
    <div class="dash-modal lv-decision-modal" role="dialog" aria-label="Reject leave">
      <div class="dash-modal-header">
        <div style="min-width: 0;">
          <h6 class="dash-modal-title">Reject leave</h6>
          <p class="dash-modal-subtitle">The employee is emailed the decision. Nothing comes off their balance.</p>
        </div>
        <button type="button" class="side-drawer-close" aria-label="Close" @click="close"><i class="pi pi-times"></i></button>
      </div>

      <div class="dash-modal-body">
        <leaveRequestSummary :request="selectedLeaveRequest" :leaveType="leaveType" />
      </div>

      <div class="dash-modal-footer">
        <button type="button" class="btn btn-custom-secondary" :disabled="saving" @click="close">Cancel</button>
        <button type="button" class="btn btn-danger-solid" :disabled="saving" @click="reject">
          <span v-if="saving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span v-else><i class="pi pi-times"></i> Reject</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import leaveRequestSummary from '@/components/leave_request/Leave_Request_Summary.vue';
import { REJECT_LEAVE_REQUEST } from '@/store/action_types';
import { TOAST_GLOBAL_CONFIG } from '@/utils/const';

export default {
  name: 'RejectLeaveRequestModal',
  components: { leaveRequestSummary },
  props: {
    selectedLeaveRequest: { type: Object, required: true },
    leaveType: { type: Object, default: null },
  },
  emits: ['closeRejectLeaveRequestModal', 'refreshLeaveRequests'],
  computed: {
    saving() {
      return this.$store.getters.leaveRequest.isLoading;
    },
  },
  methods: {
    close() {
      if (!this.saving) this.$emit('closeRejectLeaveRequestModal');
    },
    async reject() {
      const ok = await this.$store.dispatch(REJECT_LEAVE_REQUEST, { id: this.selectedLeaveRequest.id });
      if (!ok) return;
      this.$toast.success('Leave rejected', TOAST_GLOBAL_CONFIG);
      this.$emit('refreshLeaveRequests');
      this.$emit('closeRejectLeaveRequestModal');
    },
    onKey(event) {
      if (event.key === 'Escape') this.close();
    },
  },
  mounted() {
    document.addEventListener('keydown', this.onKey);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKey);
  },
};
</script>
